import { gql } from "@apollo/client";

export const getAllFormQuery = gql`
query{
  getAllFormTemplate {
    message
    response
  }
}
`;